<script setup>
import ContentList from "@/components/list/ContentList";
import PathItemDetails from "@/components/list/PathItemDetails";
import {usePathsStore} from "@/stores/PathStore";
import {useRoute} from "vue-router";
import {onBeforeMount, reactive} from "vue";

const route = useRoute();
import LoadingSpinner from "@/shared/LoadingSpinner";

const store = usePathsStore();
const state = reactive({
    loading: false,
});

async function loadSinglePath() {
    state.loading = true;
    await store.getPath(route.params.id);
    document.title = store.pathContent.name;
    state.loading = false;
}

onBeforeMount(async () => {
    await loadSinglePath();
});
</script>

<template>
    <div class="bg-[#FBFBFD]">
        <loading-spinner v-if="state.loading"/>
        <div v-else>
            <div class="container mx-auto max-w-5xl px-4 pt-8">
                <path-item-details :path="store.pathContent"/>
                <content-list :content_list="store.pathItems"/>
                <div class="flex items-center justify-center "
                     v-if="store.pathItems && store.pathItems.length < 1">
                    <div class="text-center text-2xl font-bold">
                        {{ $tt('path_page__no_content_found') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

